export var VARIANT_SOFT = 'soft';
export var VARIANT_SOLID = 'solid';
export var THEME_MODE_LIGHT = 'light';
export var THEME_MODE_DARK = 'dark';
export var BOTPRESS_DEFAULT_CONFIG = {
  composerPlaceholder: 'Ask something here!',
  botName: 'Customer service',
  botAvatar: '',
  botDescription: '',
  color: '',
  variant: VARIANT_SOFT,
  themeMode: THEME_MODE_LIGHT,
  additionalStylesheetUrl: '',
  fontFamily: undefined,
  radius: 4,
  email: {},
  phone: {},
  website: {},
  termsOfService: {},
  privacyPolicy: {},
  allowFileUpload: false
};